// Type-only import: the dashboard never bundles server code.
import type { AppRouter } from "@loot-os/functions/src/dashboard-api/trpc/router.js";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import {
  createTRPCContext,
  type inferOutput,
  type TRPCOptionsProxy,
} from "@trpc/tanstack-react-query";
import { DASHBOARD_API_URL } from "./env";
import { getActiveEnvironmentId } from "./environment";
import { getRouteTenantId } from "./tenantScope";

export const { TRPCProvider, useTRPC } = createTRPCContext<AppRouter>();

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${DASHBOARD_API_URL}/trpc`,
      // No environment header = the server scopes to the tenant's live
      // environment. The tenant header is honored only for staff users.
      headers: () => {
        const headers: Record<string, string> = {};
        const environmentId = getActiveEnvironmentId();
        if (environmentId) headers["x-loot-environment"] = environmentId;
        const tenantId = getRouteTenantId();
        if (tenantId) headers["x-loot-tenant"] = tenantId;
        return headers;
      },
      fetch: (url, options) => fetch(url, { ...options, credentials: "include" }),
    }),
  ],
});

/** What `users.get` returns: the customer page and the tables it hands rows to share it. */
export type UserDetail = inferOutput<TRPCOptionsProxy<AppRouter>["users"]["get"]>;
